import React from 'react';

import Tabs from 'brandComponents/Tabs';

import {ITabContentfulProps} from './ITabContentful';

const TabContentful = (props: ITabContentfulProps) => {
	const hasContent = !!props?.content;

	if (hasContent) {
		return <Tabs.TabPane {...props}>{props.content}</Tabs.TabPane>;
	}

	return <></>;
};

export default TabContentful;
